import React, {useEffect, useState} from "react";
import { ColorPicker, Space, Table } from "antd";
import { useSelector, useDispatch } from 'react-redux';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import { updateselectedextendedprops } from "../../../../store/cofig_data";
import AssetTagsRetrieval from '../AssetTagsRetrieval';
import { getassets } from "../../../../Restclient/datacollection"; 
import { Typography, Select, MenuItem, FormControl, InputLabel, TextField, InputAdornment } from '@mui/material';

var defaultjson = {
    "tagpropslist": [],
    "font": {
        "fontsize": 14,
        "fonttype": "Roboto",
        "color": "#000000"
    }
}

var Fonttypelist = [
    "Roboto",
    "Arial, sans-serif",
    "Helvetica, sans-serif",
    "Verdana, sans-serif",
    "Trebuchet MS, sans-serif",
    "Gill Sans, sans-serif",
    "Noto Sans, sans-serif",
    "Avantgarde, TeX Gyre Adventor, URW Gothic L, sans-serif",
    "Optima, sans-serif",
    "Arial Narrow, sans-serif",
    "sans-serif",
    "Times, Times New Roman, serif",
    "Didot, serif",
    "Georgia, serif",
    "Palatino, URW Palladio L, serif",
    "Bookman, URW Bookman L, serif",
    "New Century Schoolbook, TeX Gyre Schola, serif",
    "American Typewriter, serif",
    "serif",
    "Andale Mono, monospace",
    "Courier New, monospace",
    "Courier, monospace",
    "FreeMono, monospace",
    "OCR A Std, monospace",
    "DejaVu Sans Mono, monospace",
    "monospace"
]

export default function Areachartcardprops (props) {
    const theme = useSelector((state) => state.themedata.theme)
    const dispatch = useDispatch()

    const [addtagflag, setAddtagflag] = useState(false)
    const [buttontext, setButtontext] = useState("Add")
    const [tabledata, setTabledata] = useState([])
    const [assetdata,setAssetData] = useState(null);
    const [selectedTag, setSelectedTag] = useState({ tagname: '', tagunit: '',std_tagname:''});
    const [selectedAsset, setSelectedAsset] = useState({asset_name:'', device_id:''});
    const [t_color, setT_color] = useState("#000000")
    const [b_color, setB_color] = useState("#000000")
    const [tagdisc, setTagdisc] = useState("")
    const [tagdiscflag, setTagdiscflag] = useState(false)
    const [updatekey, setUpdatekey] = useState("")
    const [textfontsize, setTextfontsize] = useState(14)
    const [textfonttype, setTextfonttype] = useState("Roboto")
    const [f_color, setF_color] = useState("#000000")

    const columns = [
        {
            title: 'Datapoint Name',
            dataIndex: 'datapointname',
            //width: 150,
        },
        {
            title: 'Text Color',
            dataIndex: 'textcolor',
            render: (_, record) => (
                <div style={{height: '20px', width: '40px', backgroundColor: record.textcolor}}>
                    
                </div>
            )
            //width: 150,
        },
        {
            title: 'Background Color',
            dataIndex: 'backgroundcolor',
            render: (_, record) => (
                <div style={{height: '20px', width: '40px', backgroundColor: record.backgroundcolor}}>
                    
                </div>
            )
        },
        {
            title: 'Discription',
            dataIndex: 'discription',
        },
        {
            title: 'Action',
            dataIndex: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <a onClick={() => handleeditdata(record)}> Edit </a>
                    <a onClick={() => handledeletedata(record)}> Delete </a>
                </Space>
            )
        }
    ];

    const handleeditdata = (record) => {
        //console.log("delete record ", record)
        setButtontext("Update")
        if(addtagflag) {
            setAddtagflag(false)
            setAddtagflag(true)
        } else {
            setAddtagflag(true)
        }
        setUpdatekey(record.key)
        setT_color(record.textcolor)
        setB_color(record.backgroundcolor)
        setTagdisc(record.discription)
        setTagdiscflag(record.discriptionflag)

    }

    const handledeletedata = (record) => {
        console.log("delete record ", record)
        var oldtabledata = [...tabledata]
        var finaltabledata = oldtabledata.filter((item) => item.key !== record.key)
        setTabledata(finaltabledata)
        defaultjson.tagpropslist = finaltabledata
        props.callbackpropsupdate(defaultjson)
        dispatch(updateselectedextendedprops(JSON.stringify(defaultjson)))
    }

    const handleaddtagflag = () => {
        /*setButtontext("Add")
        setT_color("#000000")
        setB_color("#000000")
        setTagdisc("")
        setTagdiscflag(false)*/
        if(addtagflag) {
            setAddtagflag(false)
            setAddtagflag(true)
        } else {
            setAddtagflag(true)
        }
    }

    const handleCloseaddtag = () => {
        setAddtagflag(false)
    }

    const handleaddtagtotable = () => {
        console.log("Add clicked", tabledata)
        if(buttontext === "Add") {
            var oldtabledata = [...tabledata]
            var tablerow  = {
                key: selectedTag.tagname + tagdisc,
                datapointname: selectedTag.tagname,
                textcolor: t_color,
                backgroundcolor: b_color,
                discription: tagdisc,
                discriptionflag: tagdiscflag
            }
            console.log("tablerow ",tablerow)
            oldtabledata.push(tablerow)
            setTabledata(oldtabledata)
            defaultjson.tagpropslist = oldtabledata
            props.callbackpropsupdate(defaultjson)
            dispatch(updateselectedextendedprops(JSON.stringify(defaultjson)))
        } else if(buttontext === "Update"){
            var oldtabledata = [...tabledata]
            for(let i=0; i<oldtabledata.length; i++) {
                if(oldtabledata[i].key === updatekey) {
                    oldtabledata[i].datapointname = selectedTag.tagname
                    oldtabledata[i].textcolor = t_color
                    oldtabledata[i].backgroundcolor = b_color
                    oldtabledata[i].discription = tagdisc
                    oldtabledata[i].discriptionflag = tagdiscflag
                }
            }
            setTabledata(oldtabledata)
            defaultjson.tagpropslist = oldtabledata
            props.callbackpropsupdate(defaultjson)
            dispatch(updateselectedextendedprops(JSON.stringify(defaultjson)))
        }
        setAddtagflag(false)
    }

    const handletagdiscchange = (e) => {
        setTagdisc(e.target.value)
    }

    const handle_b_color = (value) => {
        setB_color(value.toHexString())
    }

    const handle_t_color = (value) => {
        setT_color(value.toHexString())
    }

    const handlediscflagchange = (e) => {
        console.log("called")
        setTagdiscflag(e.target.checked)
    }

    const callbackassetlist = (res) => {
        console.log("asset list ", res)
        setAssetData(res)
    }
    
    const handletextfontsizechange = (e) => {
        setTextfontsize(e.target.value)
        defaultjson.font.fontsize = e.target.value
        props.callbackpropsupdate(defaultjson)
        dispatch(updateselectedextendedprops(JSON.stringify(defaultjson)))
    }

    const handletextfonttype = (e) => {
        setTextfonttype(e.target.value)
        defaultjson.font.fonttype = e.target.value
        props.callbackpropsupdate(defaultjson)
        dispatch(updateselectedextendedprops(JSON.stringify(defaultjson)))
    }

    const handle_f_color = (color) => {
        setF_color(color.toHexString())
        defaultjson.font.color = color.toHexString()
        props.callbackpropsupdate(defaultjson)
        dispatch(updateselectedextendedprops(JSON.stringify(defaultjson)))
    }

    useEffect(() => {
        getassets(callbackassetlist)

    },[])
    return(
        <div style={{ display: 'flex', flexDirection: 'column'}}> 
            <div
                style={{
                    backgroundColor: theme === 'dark' ? '#1E1E1E' : '#EFEFEF',
                    padding: '10px',
                    marginBottom: '10px'
                }}
            >
                <div style={{display: 'flex', marginBottom: '10px'}}>
                    <Typography style={{marginBottom: '15px', fontSize: 18, fontWeight: 500, color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}> Datapoint List </Typography>
                    <div style={{flexGrow: 1}}></div>
                    <button 
                        style={{
                            padding: '2px 20px',
                            backgroundColor: '#005C8E',
                            color: '#FFFFFF',
                            border: 'none',
                            borderRadius: '20px',
                            fontSize: '16px',
                            fontWeight: 700,
                            fontFamily: 'Roboto',
                            cursor: 'pointer',  
                        }}
                        onClick={handleaddtagflag}
                    >
                        Add Datapoint
                    </button>
                </div>
                
                <Table
                    columns={columns}
                    dataSource={tabledata}
                    pagination={false}
                    scroll={{
                        y: 100,
                    }}
                    className="anttable"
                />
            </div>
            {addtagflag &&
                <div
                    style={{
                        backgroundColor: theme === 'dark' ? '#1E1E1E' : '#EFEFEF',
                        padding: '10px',
                        marginBottom: '10px'
                    }}
                >
                    <div style={{display: 'flex', marginBottom: '10px'}}>
                        <Typography style={{marginBottom: '15px', fontSize: 18, fontWeight: 500, color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}> Datapoint Selection </Typography>
                        <div style={{flexGrow: 1}}></div>
                        <button 
                            style={{
                                padding: '6px 15px',
                                backgroundColor: 'transparent',
                                color: '#7E7E7E',
                                border: '1px solid',
                                borderColor:theme === 'dark' ? '#7E7E7E' : '#7E7E7E',
                                borderRadius: '20px',
                                fontSize: '16px',
                                fontWeight: 700,
                                fontFamily: 'Roboto',
                                cursor: 'pointer',
                                marginRight: '10px'
                            }}
                            onClick={handleCloseaddtag}
                        >
                            Close
                        </button>
                        <button 
                            style={{
                                padding: '2px 20px',
                                backgroundColor: '#005C8E',
                                color: '#FFFFFF',
                                border: 'none',
                                borderRadius: '20px',
                                fontSize: '16px',
                                fontWeight: 700,
                                fontFamily: 'Roboto',
                                cursor: 'pointer',  
                            }}
                            onClick={handleaddtagtotable}
                        >
                            {buttontext}
                        </button>
                    </div>
                    
                    <div style={{display: 'flex', justifyContent: 'space-between', flexDirection: 'column'}}>
                        <div style={{display: 'flex', justifyContent: 'space-between', textAlign: 'center'}}>
                            <AssetTagsRetrieval assetdata={assetdata} setSelectedTag={setSelectedTag} setSelectedAsset={setSelectedAsset}/>
                            <TextField
                                id="Fontsize"
                                label={ <Typography style={{fontSize: 20, fontWeight: 500, color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}> Data Discription </Typography> }
                                variant="standard"
                                //type="number"
                                InputProps={{
                                    startAdornment: (
                                    <InputAdornment position="start">
                                    </InputAdornment>
                                    ),
                                    style: {
                                        color: "var(--PrimaryText)"
                                    }
                                }}
                                sx={{width: '300px', marginBottom: '20px', '& .MuiInput-underline:before': { borderBottomColor: "var(--PrimaryText)" }}}
                                value={tagdisc}
                                onChange={handletagdiscchange}
                            />
                        </div>
                        <div style={{display: 'flex', justifyContent: 'space-between', textAlign: 'center'}}>
                            <div style={{marginBottom: '20px', marginTop: '15px'}}>
                                <Space style={{marginRight: '20px'}}>
                                    <ColorPicker 
                                        //presets={presets} 
                                        value={t_color} 
                                        onChangeComplete={(value) => handle_t_color(value)}
                                        size="small"
                                        getPopupContainer={(triggerNode) => {
                                            return triggerNode.parentNode;
                                        }}
                                    />
                                    <span className={`text_typography`}> Text </span>
                                </Space>
                            </div>
                            
                            <div style={{marginBottom: '20px', marginTop: '15px'}}>
                                <Space style={{marginRight: '20px'}}>
                                    <ColorPicker 
                                        //presets={presets} 
                                        value={b_color} 
                                        onChangeComplete={(value) => handle_b_color(value)}
                                        size="small"
                                        getPopupContainer={(triggerNode) => {
                                            return triggerNode.parentNode;
                                        }}
                                    />
                                    <span className={`text_typography`}> Background </span>
                                </Space>
                            </div>
                            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                <Checkbox 
                                    checkedIcon={<CheckBoxOutlinedIcon />} 
                                    //defaultChecked={tagdiscflag}
                                    sx={{
                                        padding: 0,
                                        margin: 0,
                                        color: 'var(--HighlightedText_Stroke)',
                                        '& .MuiSvgIcon-root': {
                                            fontSize: '20px',
                                            color: 'var(--HighlightedText_Stroke)'
                                        }
                                    }} 
                                    style={{marginRight: '5px'}}
                                    checked = {tagdiscflag}
                                    onChange={handlediscflagchange}
                                />
                                <Typography style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C'}}> Show Discription </Typography>
                            </div>
                        </div>
                    </div>
                </div>
            }
            <div
                style={{
                    backgroundColor: theme === 'dark' ? '#1E1E1E' : '#EFEFEF',
                    padding: '10px',
                    marginBottom: '10px'
                }}
            >
                <Typography style={{marginBottom: '15px', fontSize: 18, fontWeight: 500, color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}> Font </Typography>
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <TextField
                        id="Fontsize"
                        label={ <Typography style={{fontSize: 20, fontWeight: 500, color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}> Value Font Size </Typography> }
                        variant="standard"
                        type="number"
                        InputProps={{
                            startAdornment: (
                            <InputAdornment position="start">
                            </InputAdornment>
                            ),
                            style: {
                                color: "var(--PrimaryText)"
                            }
                        }}
                        sx={{width: '300px', marginBottom: '20px', '& .MuiInput-underline:before': { borderBottomColor: "var(--PrimaryText)" }}}
                        value={textfontsize}
                        onChange={handletextfontsizechange}
                    />

                    <FormControl variant="filled" sx={{ minWidth: 120, width: '300px', marginBottom: '20px', padding: '0px'}}>
                        <InputLabel style={{color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C', fontSize: 18, fontWeight: 400}}> Value Font Type</InputLabel>
                        <Select
                            labelId="demo-simple-select-standard-label"
                            id="demo-simple-select-standard"
                            value={textfonttype}
                            onChange={handletextfonttype}
                            //input={<InputLabel sx={{fontSize: '2rem'}} label="Tag" />}
                            label= {<Typography style={{fontSize: 20, fontWeight: 500, color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}> Value Font Type </Typography> }
                            
                            sx={{
                                border: 0,
                                width: '300px',
                                bgcolor: 'transparent',
                                color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C',
                                fontSize: "18px",
                                fontFamily: 'Roboto',
                                fontWeight: 400,
                                textAlign: 'left',
                                borderRadius: 0,
                                marginRight: '0px',
                                p: 0,
                                "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                    borderColor: "red"
                                    },
                                    "&:hover fieldset": {
                                    borderColor: "yellow"
                                    },
                                    "& .Mui-focused fieldset": {
                                    borderColor: "green"
                                    }
                                },
                                '& .MuiOutlinedInput-input': {p: 0},
                                '& .MuiOutlinedInput-underline': {borderBottom: '2px soild'},
                                '& .MuiOutlinedInput-underline:before': { borderBottomColor: theme === 'dark' ? '#FFFFFF' : '#3C3C3C' },
                                '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    border: 0,
                                    fontSize: 25 
                                },
                                /*'& .MuiOutlinedInput-notchedOutline ': {
                                    width: '122.35px',
                                    //height:'24px',
                                    border: 0,
                                    
                                    padding: 0
                                },*/
                                '& .MuiInputLabel-root': { display: 'none', legend: 'none', fontSize: "14px"  },
                                '& .MuiSelect-select': {
                                    paddingTop: "25px",
                                    paddingBottom: "0px"
                                }
                            }}
                            //InputLabelProps={{ shrink: true, fontSize: "18px" }}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        bgcolor: theme === 'dark' ? '#3C3C3C' : '#C1C1C1',
                                        borderBottom: '2px solid #008CD7',
                                        borderRadius: 0,
                                        boxShadow: 'none',
                                        maxHeight: '250px',
                                        overflow: 'auto',
                                        color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C',
                                    }
                                },
            
                            }}
                        >
                            {
                                Fonttypelist.map((name) => {
                                    return(
                                        <MenuItem sx={{ fontSize: '16px', fontFamily: 'Roboto', fontWeight: 400, }} value={name}>
                                            {name}
                                        </MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </FormControl>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between', textAlign: 'center'}}>
                    <div style={{marginBottom: '20px', marginTop: '15px'}}>
                        <Space style={{marginRight: '20px'}}>
                            <ColorPicker 
                                //presets={presets} 
                                value={f_color} 
                                onChangeComplete={(value) => handle_f_color(value)}
                                size="small"
                                getPopupContainer={(triggerNode) => {
                                    return triggerNode.parentNode;
                                }}
                            />
                            <span className={`text_typography`}> Text </span>
                        </Space>
                    </div>
                </div>
            </div>
        </div>
    )
}